import _ from 'lodash';
import { FC } from 'react';
import { Box } from '@wix/design-system';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import PurchaseCount from './PurchaseCount';
import TemplateRating from './TemplateRating';
import VerticalDivider from '@components/VerticalDivider';
import s from './ReviewSummary.module.scss';

export const REVIEW_SUMMARY_DATA_HOOKS = {
  container: 'review-summary-container',
  templateRatingSection: 'review-summary-template-rating-section',
  purchaseCount: 'review-summary-purchase-count',
  averageRating: 'review-summary-average-rating',
  reviewCount: 'review-summary-review-count',
};

interface Props {
  includeReviewsLink?: boolean;
  useMiniPurchaseCount?: boolean;
}

const ReviewSummary: FC<Props> = ({
  includeReviewsLink = true,
  useMiniPurchaseCount = false,
}) => {
  const {
    reviewsInfo,
    purchaseCount,
    template: { price },
  } = useTemplateContext();

  const showPurchases = purchaseCount > 0;

  return (
    <Box
      direction="horizontal"
      dataHook={REVIEW_SUMMARY_DATA_HOOKS.container}
      verticalAlign="middle"
    >
      <Box verticalAlign="middle">
        <TemplateRating
          averageRating={reviewsInfo?.average}
          reviewCount={reviewsInfo?.total}
          includeReviewsLink={includeReviewsLink}
        />
        {showPurchases && <VerticalDivider className={s.verticalDivider} />}
        {showPurchases && (
          <PurchaseCount
            purchaseCount={purchaseCount}
            isMini={useMiniPurchaseCount}
            isFree={price === 0}
          />
        )}
      </Box>
    </Box>
  );
};

export default ReviewSummary;
